import Paper from 'components/Paper'

export const PrebidStackForm = (): JSX.Element => <Paper />
